import {
  Box,
  P,
  H3,
  Icon,
  Color,
  TypePreset,
  Glyph,
  ColorPreset,
  useTheme,
  AlignItems,
  FontWeight,
  Text,
  HoverEffect,
  PlainButton,
} from "@gocardless/flux-react";

import { Route, routerPush } from "src/common/routing";

const BankSelectFailureNotification = () => {
  const { theme } = useTheme();
  return (
    <Box
      borderColor={ColorPreset.BorderOnLight_04}
      borderWidth={1}
      borderRadius={1}
      bg={ColorPreset.BackgroundLight_01}
      spaceBelow={3}
    >
      <Box
        gutterH={2}
        gutterV={2}
        bg={Color.Alert_50}
        css={{
          borderRadius: "16px 16px 0px 0px",
        }}
      >
        <Box layout="flex" alignItems={AlignItems.Center}>
          <Box gutterH={1}>
            <Icon
              name={Glyph.ExclamationCircle}
              color={Color.Warning_300}
              size="32px"
            />
          </Box>

          <H3 preset={TypePreset.Heading_03}>
            We had trouble verifying your bank account
          </H3>
        </Box>
      </Box>
      <Box
        gutterH={2}
        gutterV={2}
        css={{
          borderTop: `1px solid ${theme.color(ColorPreset.BorderOnLight_04)}`,
        }}
      >
        <P>
          Please add your bank account manually below, or try again to
          <PlainButton
            effect={HoverEffect.TextDecoration}
            textDecoration="underline"
            onClick={() => {
              routerPush({
                route: Route.BankDetailsSelect,
              });
            }}
          >
            <Text weight={FontWeight.SemiBold}>
              connect using online or mobile banking
            </Text>
          </PlainButton>
        </P>
      </Box>
    </Box>
  );
};

export default BankSelectFailureNotification;
